import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { AdminPageHeader } from '..';
import { Table } from '../../shared';
import { DIGITAL_LABOR_LAW_POSTER, DIGITAL_LABOR_LAW_POSTER_COLUMNS, QUERY_KEYS } from '../../../constants';
import { usePagination } from '../../../hooks';
import { getAllDigitalLaborLawPoster } from '../../../utils/apiServices/digitalLaborLawPosterAPI';
import { AddDigitalLaborLawPosterModal } from '../../shared/Modal/AddDigitalLaborLawPosterModal';
import { popup } from '../../../utils';
import { useDebouncedValue } from '../../../hooks/useDebounceValue';

export const DigitalLaborLawPosters = () => {
    const [response, setResponse] = useState({
        data: [],
        count: 1,
    });
    const pagination = usePagination(response.data.length, response.count);
    const [search, setSearch] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);

    const [debouncedSearch] = useDebouncedValue(search, 500);
    const { data, isFetching, isFetched, isError, error } = useQuery({
        queryKey: [
            QUERY_KEYS.DIGITAL_LABOR_POSTERS,
            debouncedSearch,
            pagination.limit,
            pagination.offset,
        ],
        queryFn: async () =>
            await getAllDigitalLaborLawPoster({
                limit: pagination.limit,
                offset: pagination.offset,
                search: debouncedSearch,
            }),
        select: (data) => ({ data: data.data, count: data.count }),
        placeholderData: { data: [], count: 0 },
    });

    if (isError) popup('error', error.message);

    useEffect(() => {
        if (data && isFetched) {
            setResponse(data);
        }
    }, [data, isFetched]);

    return (
        <>
            <AdminPageHeader
                showAddButton
                heading={DIGITAL_LABOR_LAW_POSTER.PAGE_HEADING}
                buttonText={DIGITAL_LABOR_LAW_POSTER.ADD_BUTTON_TEXT}
                handleAddClick={() => {
                    setShowAddModal(true);
                }}
                AddModal={
                    showAddModal ? (
                        <AddDigitalLaborLawPosterModal
                            showAddModal={showAddModal}
                            setShowAddModal={setShowAddModal}
                        />
                    ) : null
                }
                backbutton
                showSearchBar
                searchBarPlaceholder={DIGITAL_LABOR_LAW_POSTER.FILE_NAME_SEARCH}
                count={pagination.dataCount}
                setSearch={setSearch}
            />

            <Table
                columns={DIGITAL_LABOR_LAW_POSTER_COLUMNS}
                data={response.data}
                pagination={pagination}
                pageName={DIGITAL_LABOR_LAW_POSTER.PAGE_HEADING}
                stickyColumns={['File Name']}
                isLoading={isFetching}
            />
        </>
    );
};
